import { Controller } from '@hotwired/stimulus'

// Repaints the length badge of an editor on every keystroke. A badge rendered once by the server
// goes stale the moment the writer types, and a stale badge is worse than none: it says the prompt
// still fits while the writer pastes another page into it.
//
// The budget, the multiple and the badge classes all arrive as values, so this repeats the
// comparison the report makes and nothing else.
export default class extends Controller {
  static get targets() { return ['field', 'badge'] }
  static get values() {
    return { budget: Number, factor: Number, classes: Object, titles: Object }
  }

  connect() { this.update() }

  update() {
    const chars = this.fieldTarget.value.length
    const status = this.status(chars)
    this.badgeTarget.textContent =
      `${chars.toLocaleString()} / ${this.budgetValue.toLocaleString()}`
    this.badgeTarget.className = `badge ${this.classesValue[status]}`
    this.badgeTarget.title = this.titlesValue[status]
  }

  status(chars) {
    if (chars <= this.budgetValue) return 'ok'
    return chars > this.budgetValue * this.factorValue ? 'way_over' : 'over'
  }
}
